import { FETCH_END } from 'admin-on-rest/src/actions/fetchActions';
import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
} from 'admin-on-rest/src/rest/types';

import getFetchedAt from 'admin-on-rest/src/util/getFetchedAt';

/**
 * Add new records to the pool, and remove outdated ones.
 *
 * This is the equivalent of a stale-while-revalidate caching strategy:
 * The cached data is displayed before fetching, and stale data is removed
 * only once fresh data is fetched.
 */
// eslint-disable-next-line no-shadow
export const addRecordsFactory = (getFetchedAt) => (
  newRecords = [],
  oldRecords
) => {
  const newFetchedAt = getFetchedAt(
    newRecords.map(({ id }) => id),
    oldRecords.fetchedAt
  );

  const newRecordsById = newRecords.reduce(
    (acc, record) => ({
      ...acc,
      [record.id]: record,
    }),
    {}
  );

  const records = Object.keys(newFetchedAt).reduce(
    (acc, id) => ({
      ...acc,
      [id]: newRecordsById[id] || oldRecords[id],
    }),
    {}
  );

  Object.defineProperty(records, 'fetchedAt', {
    value: newFetchedAt,
  }); // non enumerable by default

  return records;
};

const addRecords = addRecordsFactory(getFetchedAt);

const initialState = {};
Object.defineProperty(initialState, 'fetchedAt', { value: {} }); // non enumerable by default

export default (resource) => (
  previousState = initialState,
  { payload, meta }
) => {
  if (!meta || meta.resource !== resource) {
    return previousState;
  }
  if (!meta.fetchResponse || meta.fetchStatus !== FETCH_END) {
    return previousState;
  }
  switch (meta.fetchResponse) {
    case GET_LIST:
    case GET_MANY:
    case GET_MANY_REFERENCE:
      return addRecords(payload.data, previousState);
    case GET_ONE:
    case UPDATE:
    case CREATE:
      return addRecords([payload.data], previousState);
    default:
      return previousState;
  }
};

export const getRecord = (state, id) => state[id];
